import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Vehicle } from '~/core/store/trucks/trucks.model.base';

@Injectable({
    providedIn: 'root'
})
export class CompareService {
    private apiBaseUrl = environment.apiUrl;
    comparisonChanged = new Subject<string[]>();

    constructor(private http: HttpClient) { }

    getCompareData(ids: string[]): Observable<Vehicle[]> {
        const endpoint = `${this.apiBaseUrl}InternalData/compare/compare-trucks`;
        return this.http.post<Vehicle[]>(endpoint, { ids });
    }

    removeFromComparison(truckId: string): void {
        const sessionTrucks = JSON.parse(sessionStorage.getItem('comparisionTrucks') || '[]');
        let comparisonTrucks = Array.isArray(sessionTrucks) ? sessionTrucks : [];
        comparisonTrucks = comparisonTrucks.filter(id => id !== truckId);

        sessionStorage.setItem('comparisionTrucks', JSON.stringify(comparisonTrucks));
        this.comparisonChanged.next(comparisonTrucks);
    }

    resetComparison(): void {
        sessionStorage.removeItem('comparisionTrucks');
        this.comparisonChanged.next([]);
    }

    addToComparison(truckId: string): void {
        const sessionTrucks = JSON.parse(sessionStorage.getItem('comparisionTrucks') || '[]');
        let comparisonTrucks = Array.isArray(sessionTrucks) ? sessionTrucks : [];

        if (!comparisonTrucks.includes(truckId)) {
            comparisonTrucks.push(truckId);
            sessionStorage.setItem('comparisionTrucks', JSON.stringify(comparisonTrucks));

        }
        this.comparisonChanged.next(comparisonTrucks);
    }
    getComparisonTrucksId(): string[] {
        const sessionTrucks = JSON.parse(sessionStorage.getItem('comparisionTrucks') || '[]');
        return Array.isArray(sessionTrucks) ? sessionTrucks : [];
    }
}
